import React from 'react';
import { Card, CardHeader } from '../../ui/Card';
import { StatusPill } from '../../ui/StatusPill';

const statusLabels = {
  active: ['Aktiv', 'healthy'],
  inactive: ['Inaktiv', 'moderate'],
  archived: ['Arkivert', 'ghost']
};

function formatDate(value) {
  if (!value) return 'Ingen aktivitet';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? 'Ingen aktivitet'
    : new Intl.DateTimeFormat('nb-NO', { dateStyle: 'medium' }).format(date);
}

export function AcademyParticipantTable({ participants, onSelect }) {
  return (
    <Card>
      <CardHeader
        title="Kursdeltakere"
        subtitle={`${participants.length} deltakere i resultatet`}
      />
      {participants.length === 0 ? (
        <p className="p-6 text-sm text-slate-500">Ingen deltakere samsvarer med filtrene.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px] text-left text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
              <tr>
                <th className="px-5 py-4 font-semibold">Deltaker</th>
                <th className="px-4 py-4 font-semibold">Organisasjon</th>
                <th className="px-4 py-4 text-right font-semibold">Påmeldt</th>
                <th className="px-4 py-4 text-right font-semibold">Fullført</th>
                <th className="px-4 py-4 text-right font-semibold">Kursbevis</th>
                <th className="px-4 py-4 font-semibold">Siste aktivitet</th>
                <th className="px-5 py-4 text-right font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {participants.map((participant) => {
                const [label, variant] = statusLabels[participant.status] || [
                  participant.status || 'Ukjent',
                  'ghost'
                ];

                return (
                  <tr key={participant.id} className="hover:bg-slate-50">
                    <td className="px-5 py-4">
                      <p className="font-semibold text-slate-800">{participant.name}</p>
                      {participant.email && (
                        <p className="mt-1 text-xs text-slate-500">{participant.email}</p>
                      )}
                    </td>
                    <td className="px-4 py-4 text-slate-600">{participant.organizationName}</td>
                    <td className="px-4 py-4 text-right tabular-nums">{participant.enrollmentCount}</td>
                    <td className="px-4 py-4 text-right tabular-nums">{participant.completionCount}</td>
                    <td className="px-4 py-4 text-right tabular-nums">{participant.certificateCount}</td>
                    <td className="px-4 py-4 text-slate-600">{formatDate(participant.lastActivity)}</td>
                    <td className="px-5 py-4 text-right">
                      <div className="flex items-center justify-end gap-3">
                        <StatusPill label={label} variant={variant} />
                        <button
                          type="button"
                          onClick={() => onSelect(participant)}
                          className="rounded-lg px-2 py-1 font-semibold text-blue-700 hover:bg-blue-50"
                          aria-label={`Vis deltaker ${participant.name}`}
                        >
                          Vis deltaker
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}